import * as React from "react";
import { observe, Lambda } from "mobx";
import { observer } from "mobx-react";

// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "./dict";
import { YourbetMiniBetSlipData } from "./data";
import { Icon, Loader, WrapWithAnimate } from "sb-resp-ui";

// external components
import * as CMP from "./components";
import { ButtonModifiers, OddsModifiers } from "../../enums";

/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the YourbetMiniBetSlip component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }

@observer
export class YourbetMiniBetSlip extends React.Component<{
    dataProvider: YourbetMiniBetSlipData,
    dict: BaseDict
}, {
    dataProvider: YourbetMiniBetSlipData
}> {
    dict: BaseDict
    selections!: HTMLElement | null
    stakeInput: React.RefObject<HTMLInputElement>
    disposeStakeValue: Lambda

    constructor(props) {
        super(props);

        // setup dictionary
        this.dict = this.props.dict;

        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider
        };

        this.stakeInput = React.createRef();

        this.disposeStakeValue = observe(this.state.dataProvider, "stakeValue", o => {
            if (this.stakeInput.current) {
                this.stakeInput.current.value = o.newValue;
            }
        });
    }

    componentWillUnmount() {
        this.disposeStakeValue();
    }

    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    renderSummary() {

        return (
            <div className="rj-yourbet__main-slide rj-yourbet__main-slide--center">
                {this.state.dataProvider.purchases.map(p => (
                    this.state.dataProvider.isAccepted &&
                    <div className="rj-yourbet__selections" key={`ticket-${p.id}`}>
                        <CMP.Summary
                            txt_1={this.dict.Stake}
                            txt_2={p.stake || ""}
                            odds={p.odds || ""}
                            returnTxt={this.dict.Return}
                            returnValue={p.return || ""}
                            oddsModf={OddsModifiers.accepted}
                        />
                        <CMP.Market
                            title={this.dict.TicketNumber}
                            market={p.id} />
                    </div>
                ))}
                {!this.state.dataProvider.selectionsCount && <CMP.EmptyMsg label={this.dict.EmtyMsg} />}

            </div>

        )
    }

    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    renderFooter() {
        const leftComponentStake = this.state.dataProvider.leftComponentStake;
        const leftComponentButton = this.state.dataProvider.leftComponentButton;
        const rightComp = this.state.dataProvider.rightComponent;

        return (
            <div className="rj-yourbet__section rj-yourbet__footer">

                {leftComponentButton ?
                    <CMP.Button modifier={leftComponentButton.modifier} handler={leftComponentButton.handler}>
                        {leftComponentButton.label}
                    </CMP.Button>
                    :
                    <div className="rj-yourbet__stake">
                        <CMP.Button modifier={ButtonModifiers.stake} handler={leftComponentStake.buttons.left.handler} disabled={leftComponentStake.buttons.left.disabled}>
                            <Icon i="i-14 i-o-yourbet-minus" />
                        </CMP.Button>

                        <CMP.StakeInput provider={this.state.dataProvider} handler={leftComponentStake.handler} />

                        <CMP.Button modifier={ButtonModifiers.stake} handler={leftComponentStake.buttons.right.handler} disabled={leftComponentStake.buttons.right.disabled}>
                            <Icon i="i-14 i-o-yourbet-plus" />
                        </CMP.Button>
                    </div>
                }

                <CMP.Button modifier={rightComp.modifier} handler={rightComp.handler} disabled={rightComp.disabled}>
                    {rightComp.label}
                </CMP.Button>
            </div>
        )
    }

    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    render() {
        const hasSelections = this.state.dataProvider.selectionsCount && !this.state.dataProvider.isAccepted ? " rj-yourbet__main--has-selections" : "";

        // TODO Use a setting to enable or disable the slide down animation on mount>
        return <WrapWithAnimate shouldWrap={true} animation="slideDown" duration={200} runOnMount={true}>
            <div className="rj-yourbet">
                {
                    this.state.dataProvider.purchases.map(p => (
                        this.state.dataProvider.messages(p.id).map((x, y) => (
                            <CMP.Message key={`${x.id}-${y}`} modifier={x.modifier} label={x.label} type={x.type}
                                handler={x.handler} />
                        )
                        )))
                }

                <div className={`rj-yourbet__main${hasSelections}`}>
                    {this.renderSummary()}
                    <div className="rj-yourbet__main-slide">
                        <div className="rj-yourbet__selections">

                            {this.state.dataProvider.purchases.map(p => (
                                this.state.dataProvider.selectionsCount > 0 && /*!this.state.dataProvider.isAccepted &&*/
                                <CMP.Summary
                                    key={p.id}
                                    txt_1={this.state.dataProvider.selectionsCount}
                                    txt_2={this.dict.SelectionLabel}
                                    odds={p.odds || ""}
                                    returnTxt={this.dict.Return}
                                    returnValue={p.return || ""}
                                    oddsModf={p.oddsUpdated ? OddsModifiers.changed : OddsModifiers.default}
                                />
                            ))}

                            <div className="rj-yourbet__selection-list" ref={x => this.selections = x}>
                                {!this.state.dataProvider.isAccepted && this.state.dataProvider.provider.selections.map((sel, i) => (
                                    <WrapWithAnimate key={sel.id} shouldWrap={i > 1} animation="scroll" container={this.selections} axis="x" runOnMount={true}>
                                        <CMP.Market
                                            title={sel.name}
                                            market={sel.eventType}
                                            handler={() => { this.state.dataProvider.removeSelection(sel.id) }}
                                            isSuspended={sel.suspended}
                                            suspendedTxt={sel.suspended ? this.dict.Danger : ""}
                                        />

                                    </WrapWithAnimate>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {this.renderFooter()}

                {this.state.dataProvider.isWaiting && <div className="rj-yourbet__loader"><Loader /></div>}

                {/* {process.env.NODE_ENV === "development" && (
                    <DevTools />
                )} */}
            </div>
        </WrapWithAnimate>;
    }
}